"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const keautils_1 = require("keautils");
const title_1 = require("./title");
/**Un panel de bootstrap estilizado */
class Panel extends React.PureComponent {
    render() {
        const propButtons = this.props.buttons;
        const botonesModal = propButtons == undefined ? [] :
            keautils_1.isArray(propButtons) ? propButtons :
                [propButtons];
        const showHeading = this.props.iconClass || this.props.title || botonesModal.length > 0;
        const style = this.props.style || "default";
        return (React.createElement("div", { className: "panel panel-" + style },
            showHeading &&
                React.createElement("div", { className: "panel-heading" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12" },
                            React.createElement(title_1.Title, { titulo: this.props.title, size: "span", iconClass: this.props.iconClass, error: this.props.error, children: botonesModal, line: false })))),
            React.createElement("div", { className: "panel-body" }, this.props.children)));
    }
}
exports.Panel = Panel;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/panel.js
// module id = 2246
// module chunks = 0